import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import UploadPage from "./pages/Upload";
import Transactions from "./pages/Transactions";
import Subscriptions from "./pages/Subscriptions";
import Savings from "./pages/Savings";
import Compare from "./pages/Compare";
import Chat from "./pages/Chat";
import Budget from "./pages/Budget";
import Digest from "./pages/Digest";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Account from "./pages/Account";
import { GuidesIndex, GuidePage } from "./pages/Guides";
import { useSeo } from "./lib/seo";
import { Loader2 } from "lucide-react";

function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    useSeo({ title: "Your money", noindex: true, path: window.location.pathname });
    if (loading || user === null)
        return <div className="min-h-screen flex items-center justify-center bg-background"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div>;
    if (!user) return <Navigate to="/login" replace />;
    return children;
}

const P = ({ children }) => <ProtectedRoute>{children}</ProtectedRoute>;

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Toaster position="top-right" theme="dark" richColors />
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/guides" element={<GuidesIndex />} />
                        <Route path="/guides/:bank" element={<GuidePage />} />
                        <Route path="/dashboard" element={<P><Dashboard /></P>} />
                        <Route path="/upload" element={<P><UploadPage /></P>} />
                        <Route path="/transactions" element={<P><Transactions /></P>} />
                        <Route path="/subscriptions" element={<P><Subscriptions /></P>} />
                        <Route path="/savings" element={<P><Savings /></P>} />
                        <Route path="/compare" element={<P><Compare /></P>} />
                        <Route path="/chat" element={<P><Chat /></P>} />
                        <Route path="/budget" element={<P><Budget /></P>} />
                        <Route path="/digest" element={<P><Digest /></P>} />
                        <Route path="/payment/success" element={<P><PaymentSuccess /></P>} />
                        <Route path="/payment/cancel" element={<P><PaymentCancel /></P>} />
                        <Route path="/account" element={<P><Account /></P>} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
